<template>
	<div>
		<el-container >
			<!-- <el-aside >
				<DeptTree/>
			</el-aside> -->
			
			<!-- <el-aside width="150px" >
				<el-input  
					placeholder="输入关键字定位"
					v-model="filterText">
				</el-input>

				<el-tree
					class="filter-tree"
					:data="tableData"
					:props="{ label: 'name' }"
					default-expand-all
					:filter-node-method="filterNode"
					ref="tree">
				</el-tree>

				<el-tree
					:data="tableData"
					:props="{ label: 'name' }"
					accordion
					@node-click="handleNodeClick">
				</el-tree>
			</el-aside> -->

			<el-container>
				<el-header >
					<el-form :inline="true">
						<el-form-item>
							<el-button type="primary" @click="dialogVisible = true">新增</el-button>
						</el-form-item>
					</el-form>
				</el-header>

				<el-main>
					<el-table
							:data="tableData"
							:height="tableHeight"
							:row-style="{height: '0px'}"
							:cell-style="{padding: '2px'}"
							:header-cell-style="{background: '#E6F2FE', height:'8px',padding:'8px'}"
							style="width: 100%;margin-bottom: 20px;margin-top: -25px;"
							row-key="id"
							border
							stripe
							default-expand-all
							:tree-props="{children: 'children', hasChildren: 'hasChildren'}">

						<el-table-column
								prop="deptName"
								label="名称"
								sortable
								show-overflow-tooltip
								width="400">
						</el-table-column>
						<el-table-column
								prop="deptNo"
								label="编号"
								sortable
								width="180">
						</el-table-column>
						<el-table-column
								prop="remark"
								label="备注"
								show-overflow-tooltip
								width="300">
						</el-table-column>
						<el-table-column
								prop="icon"
								label="操作">

							<template slot-scope="scope">
								<el-button type="text" @click="editHandle(scope.row.id)">编辑</el-button>
								<el-divider direction="vertical"></el-divider>

								<template>
									<el-popconfirm title="确定该部门删除吗？" @confirm="delHandle(scope.row.id)">
										<el-button type="text" slot="reference">删除</el-button>
									</el-popconfirm>
								</template>

							</template>
						</el-table-column>

					</el-table>
				</el-main>
			</el-container>
		</el-container>


		<!--新增对话框-->
		<el-dialog
				title="提示"
				:visible.sync="dialogVisible"
				width="600px"
				:before-close="handleClose"
				:close-on-click-modal="false">

			<el-form :model="editForm" :rules="editFormRules" ref="editForm" label-width="100px" class="demo-editForm">

				<!-- <el-form-item label="上级部门" prop="parentId">
					<el-select v-model="editForm.parentId" placeholder="请选择上级部门">
						<template v-for="item in tableData">
							<el-option :label="item.deptName" :value="item.id"></el-option>
							<template v-for="child in item.children">
								<el-option :label="child.deptName" :value="child.id">
									<span>{{ "- " + child.deptName }}</span>
								</el-option>
							</template>
						</template>
					</el-select>
				</el-form-item> -->

				<el-form-item label="上级部门" prop="parentId" label-width="100px">
					<el-select v-model="editForm.parentId" placeholder="请选择上级部门" >
						<el-option 
						:value="editForm.parentId"
              			:label="editForm.parentFullName"
						style="width: 460px;height: 200px;overflow: auto;background-color: #fff;">
							<DeptTree  @getTreeData="deptSelectNodeClick"/>
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="部门名称" prop="deptName" label-width="100px">
					<el-input v-model="editForm.deptName" autocomplete="off"></el-input>
				</el-form-item>

				<el-form-item label="部门编号" prop="deptNo" label-width="100px">
					<el-input v-model="editForm.deptNo" autocomplete="off"></el-input>
				</el-form-item>

				<el-form-item label="备注" prop="remark" label-width="100px">
					<el-input v-model="editForm.remark" autocomplete="off"></el-input>
				</el-form-item>

				<!-- <el-form-item>
					<el-button type="primary" @click="submitForm('editForm')">保存</el-button>
					<el-button @click="resetForm('editForm')">重置</el-button>
				</el-form-item> -->
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="resetForm('editForm')">取 消</el-button>
				<el-button type="primary" @click="submitForm('editForm')">确 定</el-button>
			</div>
		</el-dialog>
	</div>

</template>

<script>
	import DeptTree from "./DeptTree.vue"
	export default {
    name: "Dept",
	components:{DeptTree},
    data() {
        return {
            dialogVisible: false,
            editForm: {},
            editFormRules: {
                parentId: [
                    { required: true, message: "请选择上级部门", trigger: "blur" }
                ],
                deptName: [
                    { required: true, message: "请输入部门名称", trigger: "blur" }
                ]
            },
            tableData: []
        };
    },
	computed: {
		tableHeight: function() {
			return screen.height > 900 ? 670: 580
		}
	},
    created() {
        this.getDeptTree();
    },
    watch: {
        filterText(val) {
            this.$refs.tree.filter(val);
        }
    },
    methods: {
        getDeptTree() {
            this.$axios.get("/base/dept/list").then(res => {
                this.tableData = res.data.data;
            });
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$axios.post("/base/dept/" + (this.editForm.id ? "update" : "save"), this.editForm)
                        .then(res => {
                        this.$message({
                            showClose: true,
                            message: "保存成功",
                            type: "success",
                            onClose: () => {
                                this.getDeptTree();
                            }
                        });
                        this.dialogVisible = false;
                    });
                }
                else {
                    // console.log("error submit!!");
                    return false;
                }
            });
        },
        editHandle(id) {
            this.$axios.get("/base/dept/info/" + id).then(res => {
                this.editForm = res.data.data;
                this.dialogVisible = true;
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.dialogVisible = false;
            this.editForm = {};
        },
        handleClose() {
            this.resetForm("editForm");
        },
        delHandle(id) {
            this.$axios.post("/base/dept/delete/" + id).then(res => {
                this.$message({
                    showClose: true,
                    message: "删除成功",
                    type: "success",
                    onClose: () => {
                        this.getDeptTree();
                    }
                });
            });
        },
        filterNode(value, data) {
            if (!value)
                return true;
            return data.label.indexOf(value) !== -1;
        },
        handleNodeClick(data) {
            // console.log(data);
        },
		deptSelectNodeClick(deptdata) {
			this.$set(this.editForm, "parentId", deptdata.id);
			this.$set(this.editForm, "parentFullName", deptdata.fullName);
			// console.log(deptdata);
		}
    }
}
</script>

<style scoped >
	.el-header {
		/* background-color: #B3C0D1; */
		/* color: #333; */
		line-height: 60px;
	}
	
	.el-aside {
		color: #333;
	}
	.el-form-item .el-select {
		width: 100%;
	}
</style>